import { getShiftTotalHours } from "../../../components/StaffTable/utils";
import type { Department } from "../../../contexts/AuthProvider";
import type { ScheduleRow } from "../types";

const HOURS_DECIMAL_FACTOR = 100;

interface GetRowScheduledHoursArgs {
	row: ScheduleRow;
	department: Pick<Department, "department_id" | "breakRulesConfig">;
	jobManagementEnabled: boolean;
}

/**
 * A row's scheduled hours with the department's break rules deducted — the same figure the Day
 * Schedule staff table shows, so the printout and the screen never disagree.
 *
 * Gap rows (unfilled slots) return `undefined`: break rules are scoped by employment type, which
 * only a staffed shift has, so there is no correct net figure to show. `compareValues` ranks
 * `undefined` last, which pins gap rows to the bottom like the other staff-derived columns.
 */
export const getRowScheduledHours = ({ row, department, jobManagementEnabled }: GetRowScheduledHoursArgs): number | undefined => {
	if (!row.nurse) return undefined;
	const hours = getShiftTotalHours(
		row.shiftStart,
		row.shiftEnd,
		row.nurse.role,
		row.nurse.type,
		department,
		row.nurse.jobId ? [row.nurse.jobId] : [],
		jobManagementEnabled,
	);
	// Two decimals keeps quarter-hour breaks exact (11.75) without float noise (11.749999…).
	return Math.round(hours * HOURS_DECIMAL_FACTOR) / HOURS_DECIMAL_FACTOR;
};
